import { atom } from 'recoil';
import { localStorageEffect } from "../utils/localStorageEffect";
import { taskConfigDefault } from '../constants';

export const newTaskConfig = atom({
  key: 'newTaskConfig',
  default: {
    taskName:taskConfigDefault.taskName,
    packageName:taskConfigDefault.packageName,
    appData:taskConfigDefault.appData,
    minPackageVersion:taskConfigDefault.minPackageVersion,
    requiredData:taskConfigDefault.requiredData,
    model:taskConfigDefault.model,
    initialModelId:taskConfigDefault.initialModelId,
    initialModelName:taskConfigDefault.initialModelName,
    deviceQuery:taskConfigDefault.deviceQuery,
    estimatedDevices:taskConfigDefault.estimatedDevices,
    minDataSize:taskConfigDefault,
    maxDataSize:taskConfigDefault,
    dataSizeGte : taskConfigDefault.dataSizeGte,
    dataSizeLte : taskConfigDefault.dataSizeLte,
    numOfTargetTrainingRequestDevicesPerRound:taskConfigDefault,
    numOfTargetTrainingResponseDevicesPerRound:taskConfigDefault,
    numOfTargetEvaluationRequestDevicesPerRound:taskConfigDefault,
    numOfTargetEvaluationResponseDevicesPerRound:taskConfigDefault,
    numOfTargetTestRequestDevices :taskConfigDefault,
    numOfTargetTestResponseDevices :taskConfigDefault,
    samplingMethod:taskConfigDefault.samplingMethod,
    samplingParameter:taskConfigDefault.samplingParameter,
    aggregationAlgorithm:taskConfigDefault.aggregationAlgorithm,
    aggregationSelectionMethod: taskConfigDefault.aggregationSelectionMethod,
    maxRound:taskConfigDefault.maxRound,
    roundTimeout:taskConfigDefault.roundTimeout,
    extraTimeout:taskConfigDefault.extraTimeout,
    epoch:taskConfigDefault.epoch,
    batchSize:taskConfigDefault.batchSize,
    dropReminder:taskConfigDefault.dropReminder,
    additionalParams:taskConfigDefault.additionalParams,
    modelType:taskConfigDefault.modelType,
    numOfClasses:taskConfigDefault.numOfClasses,
  },
  effects:[localStorageEffect('newTaskConfig')]
});

export const selectedTaskState = atom({
  key: 'selectedTask',
  default: "", 
  effects:[localStorageEffect('seletedTask')]
});

export const taskListFilterState = atom({
  key: 'taskListFilterState',
  default: {
    isFilteredUserId:false,
    sortBy:"createdTime",
    ascending:false,
    itemPerPage:20,
    pageNum:1,
    pageStep:0,
  },
});

export const namespaceState = atom({
  key: 'namespaceState',
  default: {
    id: "",
    namespaceName: "",
    namespacePermission: "",
    namespaceActiveYN: "",
    namespaceUserRoleName: "",
    namespaceCreator:"" 
  }, 
  effects:[localStorageEffect('namespaceState')]
});

export const namespaceDetailState = atom({
  key: 'namespaceDetailState',
  default: {
    id: "",
    name: "",
    workspaceUserId: "",
    workspaceUserMail: "",
    permission: "",
    activeYN: "",
    roleList: [],
    createdTime: "",
    updatedTime: ""
  }, 
  effects:[localStorageEffect('namespaceDetailState')]
});

export const selectedBaseModelState= atom({
  key: 'selectedBaseModelState',
  default: "", 
  effects:[localStorageEffect('selectedBaseModelState')]
});

export const selectedModelState= atom({
  key: 'selectedModelState',
  default: "", 
  effects:[localStorageEffect('selectedModelState')]
});

export const selectedModelBestState= atom({
  key: 'selectedModelBestState',
  default: "", 
  effects:[localStorageEffect('selectedModelBestState')]
});

export const isModelDirScrollState = atom({
  key: 'isModelDirScrollState',
  default: true, 
});

export const lineageDiffState= atom({
  key: 'lineageDiffState',
  default: "", 
  effects:[localStorageEffect('lineageDiffState')]
});